import Logger from './logger';

export default class LoggerFactory {
  static create(message, calculateDebug) {
    return new Logger(message, calculateDebug);
  }
}



// WEBPACK FOOTER //
// ./~/logger-factory/src/logger-factory.js